import {useContext} from "react";

import {
    GuidePreferencesContext,
    type GuidePreferencesContextState,
} from "../internal/guide-preferences-context.ts";

/**
 * Provide access to the guide preferences.
 */
export const useGuidePreferences = (): GuidePreferencesContextState =>
    useContext(GuidePreferencesContext);
